<template>
    <div style="background:#F4F4F4">
        <el-row>
            <el-col :span="12" :offset="10">
                <h2 class="title">{{yearMonthStr}}月度汇总</h2>
            </el-col>
            <el-col class="queryform">
                <el-form :inline="true" :model="queryform" class="demo-form-inline toolbar" style="color:#111111"
                    @submit.native.prevent>
                    <el-form-item label="老人姓名">
                        <el-input v-model="queryform.oldName" placeholder="请输入老人姓名" clearable
                            @keyup.enter.native.prevent="getOldFeeList"></el-input>
                    </el-form-item>
                    <el-form-item label="老人身份证">
                        <el-input v-model="queryform.oldIdCard" placeholder="请输入老人身份证" clearable
                            @keyup.enter.native.prevent="getOldFeeList"></el-input>
                    </el-form-item>
                    <el-form-item label="月份">
                        <el-date-picker v-model="queryform.dayStr" type="month" style="width: 240px"
                            value-format="yyyy-MM" placeholder="选择月份"></el-date-picker>
                    </el-form-item>
                    <el-form-item style="margin-left:20px">
                        <el-button type="primary" style="font-size:13px" icon="el-icon-search" size="small" plain
                            @click="getOldFeeList">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col>
                <el-table :data="tableData"
                        :header-cell-style="{
                        'text-align': 'center',
                        'font-weight': '600',
                        color: '#2d2d2d',
                        'background-color': '#d4f5fa',
                        }"
                        :cell-style="{ 'text-align': 'center','font-size': '13px' }"
                        :row-style="tableRowStyle"
                        style="width: 100%">
                    <el-table-column prop="oldName" label="姓名" width="80px" align="center"></el-table-column>
                    <el-table-column prop="sex" label="性别" width="60px" align="center">
                        <template slot-scope="scope">
                            <p v-if="scope.row.sex == 0">男</p>
                            <p v-else>女</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="oldIdCard" label="身份证号" width="160px" align="center"></el-table-column>
                    <el-table-column prop="registryTime" label="入院时间"  min-width="100px" align="center"></el-table-column>
                    <el-table-column prop="bedFee" label="床位费" min-width="80px" align="center"></el-table-column>
                    <!-- <el-table-column prop="gonggongfee" label="公共服务费" min-width="80px" align="center"></el-table-column> -->
                    <el-table-column prop="hulifee" label="护理费" min-width="80px" align="center"></el-table-column>
                    <el-table-column prop="huoshifee" label="餐饮费" min-width="80px" align="center"></el-table-column>
                    <!-- <el-table-column prop="gexinfee" label="个性服务费" width="100px" align="center"></el-table-column>
                    <el-table-column prop="zhiliaofee" label="治疗费" min-width="80px" align="center"></el-table-column>
                    <el-table-column prop="dianfee" label="电费" min-width="70px" align="center"></el-table-column> -->
                    <el-table-column prop="otherFee" label="其他费用" min-width="80px" align="center"></el-table-column>
                    <el-table-column prop="totalFee" label="费用合计" min-width="80px" align="center"></el-table-column>
                    <el-table-column prop="needFee" label="应缴数" min-width="70px" align="center"></el-table-column>
                    <el-table-column label="操作" min-width="60px" align="center">
                        <template slot-scope="scope">
                            <el-button type="warning" size="mini"
                                @click="showConsumption(scope.row)">明细</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination style="color:#fff;text-align: center;margin-top:15px" background
                    layout="total, prev, pager, next" :total="total" @current-change="changePage"></el-pagination>
            </el-col>

            <!-- 消费记录 -->
            <el-dialog title="消费记录" width="60%" style="margin-top:-10vh" :visible.sync="dialogConsumption"
                :close-on-click-modal="false">
                <el-table :data="consumptionRecordList" style="width: 100%" :row-style="tableRowStyle"
                    :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="{
                        'text-align': 'center',
                        'font-size': '16px',
                        'font-weight': '600',
                        color: '#2d2d2d',
                        'background-color': '#d4f5fa',
                    }">
                    <el-table-column prop="oldName" label="老人姓名" align="center"></el-table-column>
                    <el-table-column prop="type" label="费用类型" :formatter="formatType" align="center"></el-table-column>
                    <el-table-column prop="projectType" label="项目类别" :formatter="formattype2"
                        align="center"></el-table-column>
                    <el-table-column prop="projectName" label="费用项目" align="center"></el-table-column>
                    <el-table-column prop="consumptionFee" label="金额" align="center"></el-table-column>
                    <el-table-column prop="createdTime" label="费用发生时间" align="center" width="180px"></el-table-column>
                </el-table>
                <el-pagination background @current-change="consumptionPageChange" :current-page="consumptionPage"
                    layout="total, prev, pager, next" :total="consumptionTotal" :page-size="pageSize" align="center"
                    class="fenye"></el-pagination>
                <div slot="footer" class="dialog-footer" align="center">
                    <el-button @click.native="dialogConsumption = false">关 闭</el-button>
                </div>
            </el-dialog>

        </el-row>
    </div>
</template>
<script>
export default {
    name: "financeView",
    data() {
        return {
            serviceItemsOptions: [],
            tableData: [
            ],
            total: 0,
            pageNum: 1,
            pageSize:10,
            yearMonthStr:"",
            queryform: {
                dayStr:"",
            },
            dialogConsumption: false,
            consumptionRecordList: [],
            consumptionPage: 1,
            consumptionTotal: 0,
            quertForm: {},
        };
    },
    methods: {
        changePage(val) {
            this.pageNum = val;
            this.getOldFeeList();
        },
        oldCharge() {

        },
        showConsumption(row) {
            this.consumptionPage = 1;
            this.consumptionTotal = 0;
            this.dialogConsumption = true;
            this.consumptionRecordList = [];
            this.quertForm = {
                oldId: row.oldId,
                statusList: [],
            }
            this.queryConsumptionList();
        },
        consumptionPageChange(val) {
            this.consumptionPage = val;
            this.queryConsumptionList();
        },
        queryConsumptionList() {
            let param = {
                oldId: this.quertForm.oldId,
                statusList: this.quertForm.statusList,
                pageNum: this.consumptionPage,
                yearMonthStr: this.yearMonthStr,
                pageSize: this.pageSize,
            };
            this.$postJson("omc/account/queryConsumptionRecord", param).then((res) => {
                this.consumptionRecordList = res.result.list; //列表数据
                this.consumptionTotal = Number(res.result.total); //页码total
            });
        },
        formatType(row) {
            // 0 按天消费 1 按月消费 2 单次服务收费  5 充值
            if (row.type == 0) {
                return "按天消费";
            } else if (row.type == 1) {
                return "按月消费";
            } else if (row.type == 2) {
                return "单次服务收费";
            } else if (row.type == 5) {
                return "充值";
            } else if (row.type == 6) {
                return "请假退费";
            } else if (row.type == 7) {
                return "出院退费";
            } else {
                return "其他费用";
            }
        },

        formattype2(row) {
            if (row.type == 5) {
                if (row.projectType == "1") {
                    return "现金支付";
                } else if (row.projectType == "2") {
                    return "刷卡支付";
                } else if (row.projectType == "3") {
                    return "移动支付";
                } else {
                    return row.projectType;
                }
            } else {
                return row.projectType;
            }
        },
        //修改table tr行的背景色
        tableRowStyle({ row, rowIndex }) {
            if (rowIndex % 2 == 0) {
              return "background-color: #ffffff";
            } else {
              return "background-color: #e4f5f8";
            }
        },
        //表格颜色
        rowStyle(row) {
            if (row.rowIndex % 2 == 0) {
                return { background: "#086abb", color: "#fff" };
            } else {
                return { background: "#3c8dd4", color: "#fff" };
            }
        },
        getOldFeeList() {
            let param = {
                oldName: this.queryform.oldName,
                oldIdCard: this.queryform.oldIdCard,
                dayStr: this.queryform.dayStr,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
            };
            this.yearMonthStr = this.queryform.dayStr;
            this.$postJson("omc/account/queryOldMonthFeeWithPage", param).then((res) => {
                this.tableData = res.result.list; //列表数据
                this.tableData.forEach(item=>{
                    let totalFee = 0;
                    let otherFee = 0;
                    item.needFee = item.remainder >0? 0:(0-item.remainder)
                    item.consumptionRechargeRecordVoList.forEach(item2=>{
                        if(item2.type<5){
                            totalFee = totalFee + item2.consumptionFee;
                        }else if(item2.type == 6 || item2.type == 7){
                            //退费金额
                            totalFee = totalFee - item2.consumptionFee;
                        }
                        // 调整补缴;
                        // 请假退费;
                        // 出院退费;
                        if(item2.projectType == "床位费"){
                            item.bedFee = item2.consumptionFee;
                        }
                        // else if(item2.projectType == "公共服务费"){
                        //     item.gonggongfee = item2.consumptionFee;
                        // }
                        else if(item2.projectType == "护理费"){
                            item.hulifee = item2.consumptionFee;
                        }else if(item2.projectType == "伙食费"||item2.projectType == "餐饮费"){
                            item.huoshifee = item2.consumptionFee;
                        }else if(item2.projectType == "个性化服务费"|| item2.projectType == "特色服务"){
                            item.gexinfee = item2.consumptionFee;
                        }else if(item2.projectType == "电费"){
                            item.dianfee = item2.consumptionFee;
                        }else if(item2.projectType == "治疗费"){
                            item.zhiliaofee = item2.consumptionFee;
                        }else {
                            if(item2.type<5){
                                otherFee= otherFee + item2.consumptionFee;
                            }else if(item2.type == 6|| item2.type == 7){
                                otherFee= otherFee - item2.consumptionFee;
                            }
                        }
                    })
                    item.totalFee = totalFee;
                    item.otherFee = otherFee;
                })
                this.total = Number(res.result.total); //页码total
            });
        },
        getNowFormatDate() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            var currentdate = year + seperator1 + month;
            return currentdate;
        },
    },
    mounted() {
        this.queryform.dayStr = this.getNowFormatDate();
        this.yearMonthStr = this.queryform.dayStr;
        this.getOldFeeList();
    }
};
</script>
<style scoped>
.title {
    font-size: 32px;
    margin-top: 6px;
}

.table {
    width: 100%;
    margin-top: 20px;
    border-color: #7EC0EE;
    border: 1px solid #76B8D3;
}
.queryform {
}
</style>
